const Data = [
  {
    image: "https://www.cooeecalaratjada.com/en/dms/monoHotel-Cala-Ratjada/galeria/galeria-cooee-cala-ratjada.jpg"
  },
  {
    image: "https://www.postillionhotels.com/Postillion/media/Modules/Untitled-2_1.jpg?ext=.jpg"
  },
  {
    image: "https://moosehotelandsuites.com/wp-content/uploads/2021/11/lobby-1920-1280x467.jpg"
  },
]
export default Data;